@use '../../scss/utility';
@use '../grey-box/grey-box-vars';

:host {
  display: block;
  position: relative;
}

.wrapper {
  display: grid;
  position: relative;

  ::slotted(.wb-combobox-list),
  ::slotted(.wb-control-hint),
  ::slotted(.wb-control-error) {
    grid-row: 1;
    grid-column: 1;
  }
}

slot[name='message']::slotted(*) {
  position: absolute;
  margin-inline-start: var(--grey-box-hint-padding-inline-start);
}

:host([size='s']) {
  @include grey-box-vars.wb-grey-box-s-hint-vars;
}

:host([size='m']) {
  @include grey-box-vars.wb-grey-box-m-hint-vars;
}

:host([size='l']) {
  @include grey-box-vars.wb-grey-box-l-hint-vars;
}

:host(.has-message) {
  margin-block-end: calc(#{utility.wb-pixel-to-rem(16px)} + var(--wb-form-control-parts-input-hint-padding-top));
}
